// 韩语

export default {
  t1: '완료',
  t5: '결제하기',
  t6: '연동 및 승인',
}
